<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useBookComposable } from '@/components/book/useBookComposable';
import MultiSelect from 'primevue/multiselect';

interface Props {
  roomRequests?: string[];
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:roomRequests': [value: any] }>();

const roomRequestsValue = computed({
  get() {
    return props.roomRequests;
  },
  set(value) {
    emits('update:roomRequests', value);
  }
});

const { t } = useI18n({ useScope: 'global' });
const { roomRequestSelections } = useBookComposable();

const convertCodeToName = (code: string) => {
  return roomRequestSelections.find((roomRequestSelection: any) => roomRequestSelection.code === code)?.name;
};
</script>

<template>
  <div>
    <MultiSelect display="chip" v-model="roomRequestsValue" :options="roomRequestSelections" :optionLabel="'name'" optionValue="code" :placeholder="t('book_form.select_room_requests')" class="w-full w-30rem" :maxSelectedLabels="3">
      <template #chip="scope">
        <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis max-width-chip">
          {{ convertCodeToName(scope.value) }}
        </div>
      </template>
    </MultiSelect>
  </div>
</template>

<style scoped lang="scss">
.max-width-chip {
  max-width: 200px;
}
</style>
